import MinusButton from '@components/icons/MinusButton'
import PlusButton from '@components/icons/PlusButton'

interface ICounterInputProps {
  value: number;
  onIncrementClick: () => void;
  onDecrementClick: () => void;
}

const CounterInput = ({
                        value,
                        onIncrementClick,
                        onDecrementClick,
                      }: ICounterInputProps): JSX.Element => {
  return (
    <div className="flex items-center gap-[0.375rem]">
      <div>
        <div>
          <MinusButton onClick={onDecrementClick}/>
        </div>
      </div>
      <div className="font-medium">{value}</div>
      <div>
        <PlusButton onClick={onIncrementClick}/>
      </div>
    </div>
  );
};

export default CounterInput;
